import React from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../components/Common/Breadcrumb';

const Service = () => {
  const services = [
    {
      id: 1,
      title: 'Job Visa',
      image: '/assets/service-1.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione aspernatur autem velit.'
    },
    {
      id: 2,
      title: 'Business Visa',
      image: '/assets/service-2.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione aspernatur autem velit.'
    },
    {
      id: 3,
      title: 'Diplometic Visa',
      image: '/assets/service-3.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione aspernatur autem velit.'
    },
    {
      id: 4,
      title: 'Students Visa',
      image: '/assets/service-1.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione aspernatur autem velit.'
    },
    {
      id: 5,
      title: 'Residence Visa',
      image: '/assets/service-2.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione aspernatur autem velit.'
    },
    {
      id: 6,
      title: 'Tourist Visa',
      image: '/assets/service-3.jpg',
      description: 'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione aspernatur autem velit.'
    }
  ];

  return (
    <>
      <Breadcrumb title="Our Services" />
      <div className="container-fluid service overflow-hidden pt-5">
        <div className="container py-5">
          <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="sub-style">
              <h5 className="sub-title text-primary px-3">Visa Categories</h5>
            </div>
            <h1 className="display-5 mb-4">Enabling Your Immigration Successfully</h1>
            <p className="mb-0">Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat deleniti amet at atque sequi quibusdam cumque itaque repudiandae temporibus, eius nam mollitia voluptas maxime veniam necessitatibus saepe in ab? Repellat!</p>
          </div>
          <div className="row g-4">
            {services.map((service, index) => (
              <div key={service.id} className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.2}s`}>
                <div className="service-item">
                  <div className="service-inner">
                    <div className="service-img">
                      <img src={service.image} className="img-fluid w-100 rounded" alt="Image" />
                    </div>
                    <div className="service-title">
                      <div className="service-title-name">
                        <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                          <Link to="#" className="h4 text-white mb-0">{service.title}</Link>
                        </div>
                        <Link to="#" className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4">Explore More</Link>
                      </div>
                      <div className="service-content pb-4">
                        <Link to="#"><h4 className="text-white mb-4 py-3">{service.title}</h4></Link>
                        <div className="px-4">
                          <p className="mb-4">{service.description}</p>
                          <Link to="#" className="btn btn-primary border-secondary rounded-pill text-white py-3 px-5">Explore More</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Service; 